import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: 'fes-fes-workflow-action-manuscript-add-formulardetails-history',
  templateUrl: './fes-workflow-action-manuscript-add-formulardetails-history.component.html',
  styleUrls: ['./fes-workflow-action-manuscript-add-formulardetails-history.component.scss']
})
export class FesWorkflowActionManuscriptAddFormulardetailsHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor(private messageService: MessageService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  payloadChanged(payload) {

    super.payloadChanged(payload);
  }
}
